import { render, staticRenderFns } from "./SchemaProfile.vue?vue&type=template&id=2a27e36b"
import script from "./SchemaProfile.vue?vue&type=script&lang=ts"
export * from "./SchemaProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports